import { render, staticRenderFns } from "./cell-action-base.vue?vue&type=template&id=33b69761&scoped=true"
import script from "./cell-action-base.ts?vue&type=script&lang=ts&external"
export * from "./cell-action-base.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-action-base.vue?vue&type=style&index=0&id=33b69761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b69761",
  null
  
)

export default component.exports